import { useAppSession } from "./hooks/useAppSession";
import AppLoaderComponent from "component/global/app-core/app-loader/app-loader-component";
import AppPostLoaderComponent from "component/global/app-core/post-loader-component";

import "./App.css";

const App = () => {
  const pathname = window.location.pathname || "";
  const deferSchema = pathname.startsWith("/g/") || pathname.startsWith("/pub/");

  // Manage session and authentication state
  const { isLoading } = useAppSession({ deferSchema });

  if (isLoading === true) {
    return <AppLoaderComponent />;
  }
  return <AppPostLoaderComponent />;
};

export default App;
